module.exports = __webpack_public_path__ + "static/img/rpacj5.683a053f.png";